<template>
  <v-card variant="outlined" class="mb-4 open-job-card" link @click="$emit('open', job)">
    <div class="card-accent-bar" />
    <v-card-text class="pa-4">
      <v-row no-gutters align="start">
        <v-col>
          <div class="d-flex align-center flex-wrap mb-2">
            <span class="text-subtitle-2 font-weight-bold" style="color: rgba(0,0,0,.87);">
              {{ job.OrderId }}
            </span>
            <JobTypeChip :typeId="job.JobTypeId" :typeName="job.JobTypeName" class="mx-3" />
            <v-chip size="small" variant="outlined" :color="statuscolor(job.StatusId)" class="font-weight-medium status-chip">
              {{ job.StatusName }}
            </v-chip>
          </div>

          <v-row class="text-caption">
            <v-col cols="auto" class="d-flex align-center mr-4">
              <v-icon size="x-small" class="mr-1" color="grey-darken-1">mdi-calendar-plus</v-icon>
              {{ $t("text.registered") }}: {{ formatDate(job.CreatedDate) }}
            </v-col>
            <v-col cols="auto" class="d-flex align-center mr-4" v-if="job.EstimatedTime">
              <v-icon size="x-small" class="mr-1" color="grey-darken-1">mdi-clock-outline</v-icon>
              {{ $t("text.estimated_time") }}: {{ job.EstimatedTime }} {{ $t("text.hours") }}
            </v-col>
            <v-col cols="auto" class="d-flex align-center" v-if="job.JobPriority">
              <v-icon size="x-small" class="mr-1" color="grey-darken-1">mdi-flag</v-icon>
              {{ $t("text.priority") }}: {{ job.JobPriority }}
            </v-col>
          </v-row>

          <div v-if="job.CustomerComment" class="mt-2">
            <div class="text-caption font-weight-medium">
              {{ $t("text.customer_comment") }}
            </div>
            <div class="text-body-2 comment-text mt-1">{{ job.CustomerComment }}</div>
          </div>

          <div v-if="job.InvoiceComment" class="mt-2">
            <div class="text-caption font-weight-medium">
              {{ $t("text.invocie_comment") }}
            </div>
            <div class="text-body-2 comment-text mt-1">{{ job.InvoiceComment }}</div>
          </div>

          <div v-if="job.CustomerDeliveryAdressStreet || job.CustomerDeliveryAdressCity"
            class="mt-2 d-flex align-start">
            <v-icon size="x-small" class="mr-1 mt-1" color="grey-darken-1">mdi-map-marker-outline</v-icon>
            <span class="text-caption">
              {{ [job.CustomerDeliveryAdressName, job.CustomerDeliveryAdressStreet, job.CustomerDeliveryAdressZip,
              job.CustomerDeliveryAdressCity].filter(Boolean).join(', ') }}
            </span>
          </div>
        </v-col>

        <v-col cols="auto" class="ml-2 chevron-cell">
          <v-icon color="primary" size="small">mdi-chevron-right</v-icon>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import JobTypeChip from "@/components/JobTypeChip.vue";

export default {
  name: "OpenJobCard",
  components: {
    JobTypeChip,
  },
  props: {
    job: {
      type: Object,
      required: true,
    },
  },
  methods: {
    formatDate(dateStr) {
      if (!dateStr) return "";
      return new Date(dateStr).toLocaleDateString(undefined, {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    },
  },
};
</script>

<style scoped>
.open-job-card {
  position: relative;
  overflow: hidden;
  border-radius: 8px !important;
  cursor: pointer;
}

.card-accent-bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 4px;
  background-color: var(--v-primary-base);
}

.status-chip {
  background-color: #fff;
}

.chevron-cell {
  padding-top: 6px;
}

.comment-text {
  background-color: #f9f9fb;
  padding: 8px 12px;
  border-radius: 4px;
  white-space: pre-wrap;
  max-height: 120px;
  overflow-y: auto;
}
</style>
